import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMenus } from 'src/redux/menus'
import { addSubcategory, deleteSubcategory, updateSubcategory } from 'src/redux/subcategories'
import {
  CCardHeader,
  CCollapse,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormText,
  CImage,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CFormSelect,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import { cilPencil, cilTrash } from '@coreui/icons'
import { Link } from 'react-router-dom'
import { openLink } from 'src/utils/function'
import swal from 'sweetalert'
import { toast } from 'react-toastify'

const SubCategories = () => {
  const [openMenus, setOpenMenus] = useState({})

  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }))
  }

  const [formData, setFormData] = useState({
    categoryId: '',
    name: '',
    image: '',
  })
  const [image, setImage] = useState(null)

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, image: file })
  }

  const dispatch = useDispatch()

  const { menusData } = useSelector((state) => state.menus)

  useEffect(() => {
    dispatch(getMenus())
  }, [dispatch])

  const handleSubmit = async () => {
    if (!formData.name) {
      toast('Name required!', { type: 'info' })
    } else if (!formData.image) {
      toast('Image required!', { type: 'info' })
    } else {
      const body = {
        categoryId: formData.categoryId,
        name: formData.name,
        image: formData.image,
      }
      const formDataToSend = new FormData()
      Object.keys(body).forEach((key) => {
        formDataToSend.append(key, body[key])
      })
      try {
        await dispatch(addSubcategory(formDataToSend))
        setFormData({
          categoryId: '',
          name: '',
          image: '',
        })
        setImage(null)
      } catch (error) {
        toast(error.message, { type: 'error' })
      }
    }
  }

  async function handleDelete(id) {
    await swal({
      title: 'Are you sure? ',
      text: 'You want to delete this Sub Category!',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await dispatch(deleteSubcategory(id))
      } else {
        console.log(willDelete)
      }
    })
  }

  async function handleUpdate() {
    const body = {
      categoryId: formData.categoryId,
      name: formData.name,
      image: formData.image,
    }
    const formDataToSend = new FormData()
    Object.keys(body).forEach((key) => {
      formDataToSend.append(key, body[key])
    })
    await dispatch(updateSubcategory(formData?.id, formDataToSend))
    setFormData({ name: '', categoryId: '', image: '' })
    setImage(null)
  }

  return (
    <div className="bg-light d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={8}>
            <div>
              {menusData?.map((menu) => (
                <CCard key={menu.id} className="mb-1">
                  <CCardHeader className="m-0 p-0">
                    <CButton
                      color="white"
                      onClick={() => toggleMenu(menu.id)}
                      className="w-100 text-left d-flex justify-content-between align-items-center"
                    >
                      <div className="d-flex align-items-center">
                        <CImage src={menu.icon} height={30} className="me-3" />
                        {menu.name}
                      </div>
                      <CIcon
                        icon={openMenus[menu.id] ? cilChevronTop : cilChevronBottom}
                        size="lg"
                      />
                    </CButton>
                  </CCardHeader>
                  <CCollapse visible={!!openMenus[menu.id]}>
                    <CCardBody className="m-0 p-0">
                      <CTable align="middle" className="m-0 p-0 border" hover responsive>
                        <CTableHead color="light">
                          <CTableRow>
                            <CTableHeaderCell>Image</CTableHeaderCell>
                            <CTableHeaderCell>Name</CTableHeaderCell>
                            <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
                          </CTableRow>
                        </CTableHead>
                        <CTableBody>
                          {menu?.subcategories.length > 0 ? (
                            menu?.subcategories.map((sub) => (
                              <CTableRow key={sub.id}>
                                <CTableDataCell>
                                  <Link onClick={() => openLink(sub.image)}>
                                    <CImage
                                      src={sub.image}
                                      width={80}
                                      height={50}
                                      className="rounded"
                                    />
                                  </Link>
                                </CTableDataCell>
                                <CTableDataCell>
                                  <small className="text-medium-emphasis">{sub.name}</small>
                                </CTableDataCell>
                                <CTableDataCell className="text-center">
                                  <CButtonGroup>
                                    <CButton
                                      color="danger"
                                      size="sm"
                                      onClick={() => handleDelete(sub.id)}
                                    >
                                      <CIcon icon={cilTrash} className="text-white" />
                                    </CButton>
                                    <CButton
                                      color="warning"
                                      size="sm"
                                      onClick={() => setFormData({ ...sub, categoryId: menu.id })}
                                    >
                                      <CIcon icon={cilPencil} className="text-dark" />
                                    </CButton>
                                  </CButtonGroup>
                                </CTableDataCell>
                              </CTableRow>
                            ))
                          ) : (
                            <p className="text-muted pt-2 ps-2">No subcategories available</p>
                          )}
                        </CTableBody>
                      </CTable>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              ))}
            </div>
          </CCol>
          <CCol md={9} lg={7} xl={4}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <CForm>
                  <h5 className="text-medium-emphasis mb-3">
                    {formData?.id ? 'Update' : 'Add New'} Sub Category
                  </h5>
                  <CFormSelect
                    id="categoryId"
                    label="Category"
                    className="mb-3"
                    feedbackInvalid="Please provide a Category"
                    value={formData.categoryId}
                    onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
                    required
                  >
                    <option>Select Category</option>
                    {menusData?.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </CFormSelect>
                  <CFormInput
                    placeholder="Name"
                    label="Sub Category"
                    className="mb-3"
                    value={formData.name || ''}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <div className="mb-3">
                    <CFormText>Select Image</CFormText>
                    <CFormInput type="file" size="sm" id="pickImage" onChange={handleImageChange} />
                  </div>
                  {image && (
                    <CImage
                      src={image && image}
                      style={{
                        width: '100%',
                        height: 150,
                        justifyContent: 'center',
                      }}
                    />
                  )}

                  <div className="d-grid mt-3">
                    <CButton color="success" onClick={formData?.id ? handleUpdate : handleSubmit}>
                      {formData?.id ? 'Update' : 'Submit'}
                    </CButton>
                  </div>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default SubCategories
